<template>
  <div id="institution-edit">
    <IForm ref="formInline" :model="edit" :elem="institutionElem" :rules="institutionRule"
           :label-width="100" @on-submit="toSubmit" :submit="false" :showMessage="true">

      <div slot="extend">
        <Row>
          <Col span="24"><FormItem label="机构名称" prop="name" ><el-input v-model="edit.name" type="text" placeholder="请输入机构名称" clearable maxlength="125"/></FormItem></Col>
        </Row>
        <Row>
          <Col span="24"><FormItem label="子机构名称" prop="subordinate" ><el-input v-model="edit.subordinate" type="text" placeholder="请输入子机构名称" clearable maxlength="125"/></FormItem></Col>
        </Row>
        <Row>
          <Col span="12"><FormItem label="责任医生" prop="doctor" ><el-input v-model="edit.doctor" type="text" placeholder="请输入责任医生" clearable maxlength="50"/></FormItem></Col>
          <Col span="12">
            <FormItem label="前缀" prop="prefixs">
              <el-input v-model="edit.prefixs" :clearable="true" placeholder="系统自动生成" maxlength="3" :disabled="true" @input="toInt()"/>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="24"><FormItem label="联系电话" prop="phone" ><el-input v-model="edit.phone" type="text" placeholder="请输入联系电话" clearable maxlength="15"/></FormItem></Col>
        </Row>
        <Row>
          <Col span="24"><FormItem label="联系地址" prop="address" ><el-input v-model="edit.address" type="text" placeholder="请输入联系地址" clearable maxlength="100"/></FormItem></Col>
        </Row>
        <Row>
          <Col span="24"><FormItem label="备注"><el-input v-model="edit.remark" type="text" placeholder="请输入备注" :clearable="true"  maxlength="1024"/></FormItem></Col>
        </Row>
        <Row>
          <Col span="12">
            <FormItem label="模版" prop="analysisTemplateId">
              <el-select v-model.trim="edit.analysisTemplateId" placeholder="请选择模版" clearable filterable collapse-tags style="width: 100%;">
                <el-option v-for="item in analysisList" :key="item.id" :label="item.name" :value="item.id" style="width: 100%;"/>
              </el-select>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="状态" prop="status">
              <Select v-model="edit.status">
                <Option v-for="item in statusList" :value="item.value" v-bind:key="item.value" >{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>

        <Row v-show="(!edit.id && userType <= 3) || (!edit.id && (edit.provinceCode || userType == 4))">
          <Col span="12"  v-if="!edit.id && userType <= 3">
            <FormItem label="省份" prop="provinceCode"  :required="(!edit.id && userType <= 3)?true:false">
              <Select v-model="edit.provinceCode" @on-change="changeProvince" style="width: 100%;">
                <Option v-for="item in provinceList" :value="item.code" v-bind:key="item.code" style="width: 100%;">{{ item.name }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :span="!edit.id && userType <= 3 ? 12 : 24" v-if="!edit.id && (edit.provinceCode || userType == 4)">
            <FormItem label="城市" prop="cityCode"  :required="(!edit.id && (edit.provinceCode || userType == 4))?true:false">
              <Select v-model="edit.cityCode" @on-change="changeCity" style="width: 100%;">
                <Option v-for="item in cityList" :value="item.code" v-bind:key="item.code" style="width: 100%;">{{ item.name }}</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row v-show="(!edit.id && (edit.cityCode || userType == 5)) || (!edit.id && edit.areaCode)"  :required="((!edit.id && (edit.cityCode || userType == 5)) || (!edit.id && edit.areaCode))?true:false">
          <Col span="12" v-if="!edit.id && (edit.cityCode || userType == 5)">
            <FormItem label="区" prop="areaCode">
              <Select v-model="edit.areaCode" @on-change="changeArea" style="width: 100%;">
                <Option v-for="item in areaList" :value="item.code" v-bind:key="item.code" style="width: 100%;">{{ item.name }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :span="!edit.id && (edit.cityCode || userType == 5) ? 12 : 24" v-if="!edit.id && edit.areaCode">
            <FormItem label="街道"  prop="streetCode"  :required="(!edit.id && edit.areaCode)?true:false">
              <Select v-model="edit.streetCode" style="width: 100%;">
                <Option v-for="item in streetList" :value="item.code" v-bind:key="item.code" style="width: 100%;">{{ item.name }}</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>

      </div>
    </IForm>
  </div>
</template>
<script>
import {_editInstitution,_getBaseData,_getCommunityByKey} from "@/services/manage/institutions";
import {getStreetByArea, getAreaByCity, getCityByProvince} from "@/services/manage/tenant";
export default {
  name: "InstitutionEdit",
  data() {
    return {
      provinceList:[],
      cityList:[],
      areaList:[],
      streetList:[],
      jindaList:[],
      analysisList:[],
      communitysList:[],
      accountPasswordList:[],
      organList:[],
      pageDataDown: {},
      jindaShow: false,
      capShow: true,
      organShow: false,
      gzTempalte : false,
      szTempalte : false,
      shengYiTempalte : false,
      haiZhuTempalte : false,
      yueXiuTempalte : false,
      panYuTempalte : false,
      userType : null,
      filingList:[
        {label: '关闭', value: 1},
        {label: '开启', value: 2},
      ],
      statusList:[
        {label: '启用', value: 1},
        {label: '停用', value: 2},
      ],
      edit: {
        name: "",
        subordinate: "",
        labels: "",
        prefixs: "",
        phone: "",
        role: "",
        password: "",
        status: 1,
        filing: 1,
        remark: "",
        provinceCode: "",
        cityCode : "",
        areaCode: "",
        streetCode: "",
        analysisTemplateId:"",
        targetTemplateId:"",
        communityId: "",
        jindaId: "",
        capId: "",
        organId: "",
      },
      init: "",
      institutionElem: [],
      institutionRule: {
        name: [
          {
            required: true,
            trigger: "blur",
            message: "机构名不能为空"
          }
        ],
        /*prefixs: [
          { validator: (rule, value, callback) => {
              if (!this.edit.id && !value){
                callback(new Error('前缀不能为空'));
              } else if(!this.edit.id && !/^[0-9]{3}$/.test(value)){
                callback(new Error('请输入数字'));
              }else{
                callback();
              }
            },trigger: 'blur' }
        ],*/
        doctor: [
          {
            required: false,
            trigger: "blur",
            message: "责任医生不能为空"
          }
        ],
        phone: [
          {
            required: true,
            trigger: "blur",
            message: "联系电话不能为空"
          }
        ],
        address: [
          {
            required: true,
            trigger: "blur",
            message: "联系地址不能为空"
          }
        ],
        status: [
          {
            required: true,
            trigger: "blur",
            message: "状态不能为空",
            type:'number'
          }
        ],
        provinceCode:[
          { validator: (rule, value, callback) => {
              if (!this.edit.provinceCode){
                callback(new Error('请选择省份'));
              } else {
                callback();
              }
            },trigger: 'blur' }
        ],
        cityCode:[
          { validator: (rule, value, callback) => {
              if (!this.edit.cityCode){
                callback(new Error('请选择城市'));
              } else {
                callback();
              }
            },trigger: 'blur' }
        ],
        areaCode:[
          { validator: (rule, value, callback) => {
              if (!this.edit.areaCode){
                callback(new Error('请选择区'));
              } else {
                callback();
              }
            },trigger: 'blur' }
        ],
        streetCode:[
          { validator: (rule, value, callback) => {
              if (!this.edit.streetCode){
                callback(new Error('请选择街道'));
              } else {
                callback();
              }
            },trigger: 'blur' }
        ],
        analysisTemplateId:[
          {
            required: true,
            message: "请选择模版",
            trigger: "blur",
            type:'number'
          }
        ],
        targetTemplateId: [
          { validator: (rule, value, callback) => {
              // 模拟异步验证效果
              if (this.edit.analysisTemplateId && this.edit.analysisTemplateId == 3 && !value){
                callback(new Error('请选择分析模版'));
              } else {
                callback();
              }
            },trigger: 'blur' }
        ],
      },
    };
  },
  created() {
    this.gzTempalte = this.$userSession.gzTemplate();
    this.szTempalte = this.$userSession.szTemplate();
    this.shengYiTempalte = this.$userSession.shengYiTemplate();
    this.haiZhuTempalte = this.$userSession.haiZhuTemplate();
    this.yueXiuTempalte = this.$userSession.yueXiuTemplate();
    this.panYuTempalte = this.$userSession.panYuTemplate();
    this.userType = this.$userSession.getUserType();
    // 带搜索的下拉框
    //this.remoteMethod('')
  },
  mounted() {
    this.init = Object.assign({}, this.edit);
    this.applyBaseData();
  },
  watch:{
    'edit.analysisTemplateId': {
      handler(newVal){
        if(newVal && this.shengYi(newVal, this.edit.targetTemplateId)) {
          this.jindaShow = true;
          this.capShow = true;
          this.organShow = false;
        }else if(newVal && this.yueXiu(newVal, (this.edit.targetTemplateId ? this.edit.targetTemplateId : newVal))){
          this.jindaShow = true;
          this.capShow = false;
          this.organShow = false;
        }else if(newVal && this.guangzhou(newVal, (this.edit.targetTemplateId ? this.edit.targetTemplateId : newVal))){
          this.capShow = true;
          this.jindaShow = false;
          this.organShow = false;
        }else if(newVal && this.shenzhen(newVal, (this.edit.targetTemplateId ? this.edit.targetTemplateId : newVal))){
          this.capShow = false;
          this.jindaShow = false;
          this.organShow = true;
        }else{
          this.capShow = true;
          this.jindaShow = false;
          this.organShow = false;
        }
      }
    },
    'edit.prefixs': {
      handler(newVal){
        if(newVal) {
          this.edit.labels = newVal;
        }
      }
    },
  },
  methods: {
    yueXiu(analysisTemplateId, targetTemplateId){
      return this.$userSession.yueXiuTemplate(analysisTemplateId, targetTemplateId);
    },
    shengYi(analysisTemplateId, targetTemplateId){
      return this.$userSession.shengYiTemplate(analysisTemplateId, targetTemplateId);
    },
    panYu(analysisTemplateId, targetTemplateId){
      return this.$userSession.panYuTemplate(analysisTemplateId, targetTemplateId);
    },
    guangzhou(analysisTemplateId, targetTemplateId){
      return this.$userSession.gzTemplate(analysisTemplateId, targetTemplateId);
    },
    shenzhen(analysisTemplateId, targetTemplateId){
      return this.$userSession.szTemplate(analysisTemplateId, targetTemplateId);
    },
    applyBaseData(){
      _getBaseData().then(res =>{
        this.jindaList = res.data.jindas;
        this.analysisList = res.data.analysisTemplates;
        this.communitysList = res.data.communitys;
        this.accountPasswordList = res.data.accountPasswords;
        this.organList = res.data.organs;
      })
    },
    //省份选择市
    changeProvince(code, reset){
      if(!code){
        return;
      }
      this.edit.cityCode = "";
      //根据省份编号查询市
      getCityByProvince({province : code}).then(res=>{
        this.edit.provinceCode = code;
        if(res.data){
          this.cityList = res.data;
        }else{
          this.cityList = [];
        }
      })
    },
    //市选择区
    changeCity(code, reset){
      if(!code){
        return;
      }
      this.edit.areaCode = "";
      //根据市编号查询区
      getAreaByCity({cityCode: code}).then(res=>{
        this.edit.cityCode = code;
        if(res.data){
          this.areaList = res.data;
        }else{
          this.areaList =[];
        }
      })
    },
    //区选择街道
    changeArea(code, reset){
      if(!code){
        return;
      }
      this.edit.streetCode = "";
      //根据区编号查询街道
      getStreetByArea({areaCode : code}).then(res=>{
        this.edit.areaCode = code;
        if(res.data){
          this.streetList = res.data;
        }else{
          this.streetList = [];
        }
      })
    },
    loadAreaData(){
      if(this.$userSession.getUserInfo()) {
        let userType = this.userType;
        switch (userType) {
          case 1:
          case 2:
            this.provinceList = this.$userSession.getTenants();
            this.cityList = [];
            this.areaList = [];
            this.streetList = [];
            this.institutionList = [];
            break;
          case 3:
            this.provinceList = this.$userSession.getTenants();
            if(this.provinceList && this.provinceList.length == 1){
              this.changeProvince(this.provinceList[0].code);
              this.edit.provinceCode = this.provinceList[0].code;
            }

            this.cityList = [];
            this.areaList = [];
            this.streetList = [];
            this.institutionList = [];
            break;
          case 4:
            this.provinceList = [];
            this.cityList = this.$userSession.getTenants();
            if(this.cityList && this.cityList.length == 1){
              this.changeCity(this.cityList[0].code);
              this.edit.cityCode = this.cityList[0].code;
            }

            this.areaList = [];
            this.streetList = [];
            this.institutionList = [];
            break;
          case 5:
            this.provinceList = [];
            this.cityList = [];
            this.areaList = this.$userSession.getTenants();
            if(this.areaList && this.areaList.length == 1){
              this.changeArea(this.areaList[0].code);
              this.edit.areaCode = this.areaList[0].code;
            }
            break;
        }
      }
    },
    handleModal(row) {
      this.$refs["formInline"].handleReset();
      this.edit = {
        name: "",
        subordinate: "",
        labels: "",
        phone: "",
        role: "",
        password: "",
        status: 1,
        filing: 1,
        provinceCode: "",
        cityCode : "",
        areaCode: "",
        streetCode: "",
        analysisTemplateId:"",
        targetTemplateId:"",
        communityId: "",
        jindaId: "",
        capId: "",
        organId: "",
      };
      if (!row) {
        this.loadAreaData();
        this.jindaShow = false;
        this.capShow = false;
        this.edit.analysisTemplateId = "";
        this.edit.targetTemplateId = "";
        this.edit.communityId = "";
        this.edit.jindaId = "";
        this.edit.capId = "";
        this.handleCreate();
      } else {
        this.handleEdit(row);
      }
    },
    handleCreate() {
      this.edit = Object.assign({}, this.init);
      this.analysisList.forEach(item=>{
        if (item.type==2){
          this.edit.analysisTemplateId=item.id
        }
      })
    },
    handleEdit(row) {
      this.edit = Object.assign({}, row);
      this.edit.prefixs = row.labels;
    },
    handleSubmit() {
      this.$refs["formInline"].handleSubmit('form');
    },
    toSubmit() {
      if (!this.edit.analysisTemplateId) {
        this.$message.warning('请选择模版');
        return;
      }
      if (this.edit.analysisTemplateId == 3 && !this.edit.targetTemplateId) {
        this.$message.warning('请选择分析模版');
        return;
      }
      if ((!this.edit.id || this.edit.id == "") && !this.edit.streetCode) {
        this.$message.warning('请先选择街道');
        return;
      }

      if(this.shengYi(this.edit.analysisTemplateId, (this.edit.targetTemplateId?this.edit.targetTemplateId:this.edit.analysisTemplateId))){

      }else if(this.yueXiu(this.edit.analysisTemplateId, (this.edit.targetTemplateId?this.edit.targetTemplateId:this.edit.analysisTemplateId))){
        this.edit.capId = "";
      }else if(this.$userSession.gzTemplate(this.edit.analysisTemplateId, (this.edit.targetTemplateId?this.edit.targetTemplateId:this.edit.analysisTemplateId))){
        this.edit.jindaId = "";
      }else{
        this.edit.capId = "";
        this.edit.jindaId = "";
      }

      _editInstitution(this.edit).then(res => {
        if (res.errcode == 1){
          if(this.edit.id && this.$userSession.getInstitutionId() == this.edit.id){
            this.$userSession.getInstitution().name = payload.name;
            this.$userSession.getInstitution().doctor = payload.doctor;
            this.$userSession.getInstitution().analysisTemplateId = payload.analysisTemplateId;
            this.$userSession.getInstitution().targetTemplateId = payload.targetTemplateId;
            this.$store.commit("USER_INFO", this.$userSession.getUserInfo());
          }

          this.$message.success(res.errmsg);
          this.$emit("on-submit", false);
        } else{
          this.$message.error(res.errmsg);
        }
      }).catch(() => {});
    },
    toInt(){
      if(this.edit.prefixs){
        this.edit.prefixs = (this.edit.prefixs + "").replace(/[^\d]+/g, '');
        this.edit.prefixs = (this.edit.prefixs + "").replace('.', '');
        this.edit.prefixs = (this.edit.prefixs + "").replace(/\./g, '');
        this.edit.prefixs = (this.edit.prefixs + "").replace(/\\./g, '');
        this.edit.prefixs = (this.edit.prefixs + "").replace('$#$', '');
      }
    }
  },
};
</script>
<style lang="postcss" scoped>
/deep/ .el-input__inner {height: 32px;line-height: 32px;}
/deep/ .el-input__icon{line-height: 32px;}
</style>
